import { Box } from '@mui/material';
import React, { useEffect } from 'react';

const ButtonDownloadPWA = (props) => {
  const [isReadyForInstall, setIsReadyForInstall] = React.useState(false);

  useEffect(() => {
    window.addEventListener('beforeinstallprompt', (event) => {
      // Prevent the mini-infobar from appearing on mobile.
      event.preventDefault();
      // Stash the event so it can be triggered later.
      window.deferredPrompt = event;
      // Remove the 'hidden' class from the install button container.
      setIsReadyForInstall(true);
    });
  }, []);

  async function downloadApp() {
    const promptEvent = window.deferredPrompt;
    if (!promptEvent) {
      // The deferred prompt isn't available.
      console.info('oops, no prompt event guardado en window');
      return;
    }
    // Show the install prompt.
    promptEvent.prompt();
    // Log the result
    // const result = await promptEvent.userChoice;
    // Reset the deferred prompt variable, since
    // prompt() can only be called once.
    window.deferredPrompt = null;
    // Hide the install button.
    setIsReadyForInstall(false);
  }

  if (props.children) {
    return <div>{isReadyForInstall && <Box onClick={downloadApp}>{props.children}</Box>}</div>;
  }

  return (
    <div>
      {isReadyForInstall && !props.children && <button onClick={downloadApp}>Descargar App</button>}
    </div>
  );
};

export default ButtonDownloadPWA;
